import designAutomation from 'src/js/modules/design-automation';

const applyInstruction = (instruction) =>
  designAutomation.utils.applyInstructions(
    designAutomation.utils.normaliseBooleanAttributes(instruction)
  );

export default applyInstruction;
